import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd"

export const CreateButton = ({ onClick, disabled }) => {
  return (
    <Button type='primary' size='middle' onClick={onClick} disabled={disabled}>
      <PlusOutlined />
    </Button>
  );
};
